import { render, staticRenderFns } from "./categorybtn.vue?vue&type=template&id=cf8904ee&"
import script from "./categorybtn.vue?vue&type=script&lang=js&"
export * from "./categorybtn.vue?vue&type=script&lang=js&"
import style0 from "./categorybtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports